export default __webpack_public_path__ + "static/realWorldImg4-30f5da303a6ee54f35221d4f768c3b11.png";